const localIdPrefix = 'local.';

export const isLocalId = (id?: string | null) =>
  !!id?.startsWith(localIdPrefix);

export const generateLocalId = () => `${localIdPrefix}${Date.now()}`;
